import PageHeading from "../components/page-heading";
import Services from "../components/services";
import { NAME } from "../constants";

const meta = {
    title: "Our Services",
    description: "We Offer Different Services To Improve Your Health",
    keywords: ["Touchlife", "Touchlife Medical Care Foundation"],
};

// Removed `: Metadata` type annotation
export const metadata = {
    title: meta.title,
    description: meta.description,
    keywords: meta.keywords,
    twitter: {
        card: "summary_large_image",
        title: meta.title,
        description: meta.description,
        siteId: "1467726470533754880",
        creator: NAME,
        creatorId: "1467726470533754880",
    },
};

export default function ServicesPage() {
    return (
        <div>
            <PageHeading title="Our Services" />
            <div className="pb-10">
                <Services />
            </div>
        </div>
    );
}
